import { type LinkProps } from 'react-router-dom';

import { LinkStyled } from './styles';

type ILinkButton = LinkProps & { disabled?: boolean };

export function LinkButton({ disabled, ...props }: ILinkButton) {
  return <LinkStyled disabled={disabled} {...props} />;
}
